module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/account-grey-98f2b60e5826963b0c75cdb71bd217d2.png";